import { render, staticRenderFns } from "./ArrowLeft.vue?vue&type=template&id=12213fc3&scoped=true&"
import script from "./ArrowLeft.vue?vue&type=script&lang=js&"
export * from "./ArrowLeft.vue?vue&type=script&lang=js&"
import style0 from "./ArrowLeft.vue?vue&type=style&index=0&id=12213fc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12213fc3",
  null
  
)

export default component.exports